export default __webpack_public_path__ + "static/media/seaside.0b5cee3e.jpg";